import { TripsTable } from "@/features/trips/trips-table";

const TripsScreen = () => {
  return (
    <div className="p-4">
      <TripsTable />
    </div>
  );
};

export default TripsScreen;
